import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  TextField,
  Typography,
  Button,
  MenuItem
} from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment'
import { EmojiFlags } from '@mui/icons-material'
import {
  setStakeAmount
} from '@modules/redux/actions'
import { getEstimatedBonus } from '@hooks/contract'

const AddStakeDialog = (props) => {
  const {
    open,
    closeModal,
    dealId,
    dealInfo,
    dealTokenInfo,
    isPending,
    stakeAmount,
    setStakeAmount,
    addStakeHandler,
    textFieldError,
    decimal
  } = props

  const [estimateBonus, setEstimateBonus] = useState(0)

  useEffect(() => {
    const initialHandler = async () => {
      const _bonus = await getEstimatedBonus(dealId, stakeAmount, dealTokenInfo)
      setEstimateBonus(_bonus > 0 ? _bonus : 0)
    }

    initialHandler()
  }, [stakeAmount, dealId, dealTokenInfo, setEstimateBonus])

  useEffect(() => {
    setStakeAmount(dealInfo.minStakeAmount / (10 ** decimal))
  }, [])

  return (
    <Backdrop
      open={open}
      className="modal-filter"
    >
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", textTransform: "uppercase" }}
        >
          Add a Stake in {dealInfo.name}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography
              variant="div"
            >
              Staking reserves your place for a future offering on this project. While staked, your funds earn interest at market rates and you may withdraw them at any time, risk-free. If the project sponsor creates an offer, you will be contacted and given the option to make a firm commitment. <br/>You can un-stake at any time for free.
            </Typography>
          </DialogContentText>
          <Box
            className="dialog-form-panel"
            sx={{ mt: 2 }}
          >
            <TextField
              variant="outlined"
              margin="dense"
              label="Deal Crypto"
              select
              fullWidth
              value="1"
              disabled
            >
              <MenuItem value="1">
                <Box
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", mr: 2 }}
                  >
                    <img src={dealTokenInfo.logo} style={{ width: "24px", height: "24px" }} alt="crypto icon" />
                  </Box>
                  <Box>{dealTokenInfo.name}</Box>
                </Box>
              </MenuItem>
            </TextField>
            <TextField
              disabled={isPending}
              variant="outlined"
              autoFocus
              margin="dense"
              label="Amount to Stake"
              type="number"
              fullWidth
              size="small"
              value={stakeAmount}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                inputProps: { min: 0 }
              }}
              helperText={
                textFieldError?.overZero ? 'Minimum stake size is over 0' :
                  textFieldError?.minAmount ? 'Minimum stake size is ' + dealInfo.minStakeAmount / (10 ** decimal) :
                    textFieldError?.maxAmount ? 'Maximum stake size is ' + dealInfo.maxStakeAmount / (10 ** decimal) : ''
              }
              error={textFieldError?.amount ? true : false}
              onChange={(e) => {
                setStakeAmount(e.target.value)
              }}
              sx={{ mt: 2 }}
            />
            <TextField
              disabled
              variant="outlined"
              autoFocus
              margin="dense"
              label="Estimated Presail Bonus"
              type="number"
              fullWidth
              size="small"
              value={estimateBonus}
              InputProps={{
                endAdornment: <InputAdornment position="start">%</InputAdornment>,
                inputProps: { min: 0 }
              }}
              helperText={
                estimateBonus > 0 ? '' : 'Presail Amount Reached.'
              }
              sx={{ mt: 2 }}
            />
            <Button
              variant="outlined"
              fullWidth
              className="btn-info"
              sx={{ mt: 2 }}
              onClick={isPending ? null : addStakeHandler}
              startIcon={<EmojiFlags />}
            >
              {isPending ? "Pending ..." : "Add Stake"}
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            fullWidth
            onClick={closeModal}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}

const mapStateToProps = ({ stake }) => ({
  stakeAmount: stake.amount
});

const mapToDispatchProps = (dispatch) => ({
  setStakeAmount: (amount) => dispatch(setStakeAmount(amount))
});

export default connect(mapStateToProps, mapToDispatchProps)(AddStakeDialog);